

import { PanelsActionTypes } from 'actionsConstants';
import { dispatch, state } from '__common/store';
import { PUT_PANELS_IN_HISTORY } from 'actions';
import { PUT_LITE_PANELS_IN_HISTORY } from 'v3/workspace/history/liteHistoryActions';
import { DEBUG } from 'debug';

const actions = [
  PanelsActionTypes.REMOVE_PANELS,
  PanelsActionTypes.ADD_PANELS,
  PanelsActionTypes.CHANGE_SINGLE_PANEL_ROOF_ZONE,
];

const historyEnabled = () => DEBUG.enablePanelsUndo || DEBUG.enablePanelsRedo || state().app?.isUbuilderLite;

const PANEL_REMOVE_HISTORY_DEBOUNCE_MS = 32;
let pendingRemoveHistoryWrite: ReturnType<typeof setTimeout> | null = null;

const shouldSeedInitialPanelsSnapshot = (history: historyState, panels: panelInState[] = []) => {
  return history.index === 0 &&
    history.panelsSnapshot.length === 1 &&
    history.panelsSnapshot[0].length === 0 &&
    panels.length > 0;
};

const compactPanelsForHistory = (panels: panelInState[] = []): panelInState[] => panels.map((panel) => {
  const {
    centerPoint,
    rTreeBounds,
    stickPoints,
    ...panelSnapshot
  } = panel;

  return {
    ...panelSnapshot,
  };
});

const writePanelsHistorySnapshot = () => {
  const { panels: { panels } } = state();
  const compacted = compactPanelsForHistory(panels);
  if (state().app?.isUbuilderLite) {
    dispatch(PUT_LITE_PANELS_IN_HISTORY(compacted));
  } else {
    dispatch(PUT_PANELS_IN_HISTORY(compacted));
  }
};

export const panelsHistoryMiddleware = store => next => action => {
  if (!action) {
    console.error('panelsHistoryMiddleware: Action is undefined!');
    return;
  }

  if (typeof action !== 'object') {
    console.error('panelsHistoryMiddleware: Action is not an object:', typeof action, action);
    return;
  }

  if (action.type === undefined) {
    console.error('panelsHistoryMiddleware: Action type is undefined:', action);
    return;
  }

  if (actions.includes(action.type) && historyEnabled()) {
    const { panels: { panels }, history } = state();

    if (shouldSeedInitialPanelsSnapshot(history, panels)) {
      dispatch(PUT_PANELS_IN_HISTORY(compactPanelsForHistory(panels)));
    }
  }

  next(action);

  if (actions.includes(action.type) && historyEnabled()) {
    if (action.type === PanelsActionTypes.REMOVE_PANELS) {
      if (pendingRemoveHistoryWrite) {
        clearTimeout(pendingRemoveHistoryWrite);
      }
      pendingRemoveHistoryWrite = setTimeout(() => {
        pendingRemoveHistoryWrite = null;
        writePanelsHistorySnapshot();
      }, PANEL_REMOVE_HISTORY_DEBOUNCE_MS);
      return;
    }

    writePanelsHistorySnapshot();
  }
};
